// extracted by mini-css-extract-plugin
export default {"mainContainer":"main-container_mainContainer__L5lmu"};